import { render, staticRenderFns } from "./AdditionalOptions.vue?vue&type=template&id=3aa4d318&scoped=true"
import script from "./AdditionalOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalOptions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdditionalOptions.vue?vue&type=style&index=0&id=3aa4d318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4d318",
  null
  
)

export default component.exports